<template>
  <div class="text-fix">
    <Header
      :key="keyHeader"
      :page="currentTab.page"
      :student="$store.state.$_student.selectedStudentPreRegistry"
      @display-invalid-tabs="setInvalidTabs"
      @set-disability="setTabDisability"
      :buttonsave="showSavedButton"
      @create-new-referral="onCreateNewReferral"
      :show-create-new-referral-option="showCreateNewReferralOption"
    />
    <div class="row">
      <div class="col-md-12">
        <div class="Sub-menu">
          <div class="shadow-bottom">
            <ul class="tab-list nav nav-pills mb-3" role="tablist">
              <li
                v-for="tab in getTabs"
                :key="tab.id"
                class="nav-item text-center"
                :class="{
                  'tabs-six': !hasAppointment,
                  'tabs-seven': hasAppointment
                }"
              >
                <a
                  class="nav-link"
                  :class="{ active: tab.isActive, disabled: tab.isDisabled }"
                  role="tab"
                  aria-selected="true"
                  aria-controls="tab-i"
                  @click="selectTab(tab)"
                >
                  {{ tab.name }}
                  <i
                    v-if="tab.invalid"
                    class="far fa-exclamation-triangle warning"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="tab-content tab-content-spacing">
          <keep-alive>
            <component
              :is="currentTab.id"
              ref="currenTab"
              v-bind="currentTab"
              :is-post-registry="this.isPostRegistry"
              :validations="validationAppointments"
              :isDisabled="currentTab.isDisabled"
              @set-disability="setTabDisability"
              @set-visibility="setTabVisibility"
              @select-tab="selectTabById"
              @set-invalid-tabs="setInvalidTabs"
              @set-button-save-visibility="setButtonVisibility"
              @updateValidationNextAppointment="validationAppointments = $event"
              @set-show-create-new-referral-option="
                onSetShowCreateNewReferralOption
              "
            />
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import Tab1 from "./tabs/Tab1";
import Tab2 from "./tabs/Tab2";
import Tab3 from "./tabs/Tab3";
import Tab4 from "./tabs/Tab4";
import Tab5 from "./tabs/Tab5";
import Tab6 from "./tabs/Tab6";
import Tab7 from "./tabs/Tab7";
import TabHeader from "./tabs/TabHeader";
import store from "@/store/index";
import StudentStatuses from "@/utils/constants/reg/studentStatuses.js";
import StudentStatusesCode from "@/utils/constants/student/studentStatuses.js";
import storeMixin from "@/mixin/storeGenerator";
import appointmentServiceManager from "@/services/api/appointment.api.js";

const APPOINTMENT_TAB_ID = "Tab5";
const POST_REGISTRY_TAB_ID = "Tab6";
const { mapState } = createNamespacedHelpers("$_student");
import alertMixin from "@quisit/mipe-utils/mixins/alert.mixin";

export default {
  name: "StudentRegistryMaster",
  mixins: [storeMixin, alertMixin],
  data() {
    return {
      showSavedButton: true,
      keyHeader: 1,
      tabs: [
        {
          id: "Tab1",
          name: "General",
          visibility: true,
          isDisabled: false,
          isActive: true,
          invalid: false,
          caption: "I",
          page: {
            tabIndex: 1,
            icon: "fas fa-clipboard-user",
            title: "Registro: General",
            routes: ["Estudiante", "Registro", "General"],
            tooltip: "Registro General"
          }
        },
        {
          id: "Tab2",
          name: "Garantías Procesales",
          visibility: false,
          isDisabled: false,
          isActive: false,
          invalid: false,
          caption: "II",
          page: {
            tabIndex: 2,
            icon: "fas fa-clipboard-list-check",
            title: "Registro: Garantías Procesales",
            routes: ["Estudiante", "Registro", "Garantías Procesales"],
            tooltip: "Garantías Procesales"
          }
        },
        {
          id: "Tab3",
          name: "Datos de Referido",
          visibility: false,
          isDisabled: false,
          isActive: false,
          invalid: false,
          caption: "II",
          page: {
            tabIndex: 3,
            icon: "fas fa-clipboard-list",
            title: "Registro: Datos de Referido",
            routes: ["Estudiante", "Registro", "Datos de Referido"],
            tooltip: "Datos de Referido"
          }
        },
        {
          id: "Tab4",
          name: "Evaluación / Servicios",
          visibility: false,
          isDisabled: false,
          isActive: false,
          invalid: false,
          caption: "II",
          page: {
            tabIndex: 4,
            icon: "fas fa-clipboard-user",
            title: "Registro: Evaluación / Servicios",
            routes: ["Estudiante", "Registro", "Evaluación / Servicios"],
            tooltip: "Evaluación / Servicios"
          }
        },
        {
          id: "Tab5",
          name: "Citas",
          visibility: false,
          isDisabled: false,
          isActive: false,
          invalid: false,
          caption: "II",
          page: {
            tabIndex: 5,
            icon: "fas fa-clipboard-user",
            title: "Registro: Citas-Evaluaciones",
            routes: ["Estudiante", "Registro", "Citas"],
            tooltip: "Registro: Citas-Evaluaciones"
          }
        },
        {
          id: "Tab7",
          name: "Proceso de Firma",
          visibility: false,
          isDisabled: false,
          isActive: false,
          invalid: false,
          caption: "II",
          page: {
            tabIndex: 7,
            icon: "fas fa-user-circle",
            title: "Registro: Proceso de Firma",
            routes: ["Estudiante", "Registro", "Proceso de Firma"],
            tooltip: "Proceso de Firma"
          }
        },
        {
          id: "Tab6",
          name: "Post-Registros",
          visibility: false,
          isDisabled: false,
          isActive: false,
          invalid: false,
          caption: "II",
          page: {
            tabIndex: 6,
            icon: "fas fa-desktop",
            title: "Registro: Post-Registros",
            routes: ["Estudiante", "Registro", "Post-Registros"],
            tooltip: "Post-Registros"
          }
        }
      ],
      hasAppointment: false,
      perstistTempRoutesPostRegistry: [
        "peiEvaluationServiceIntervention",
        "student-evaluation-history",
        "student-evaluation-history-add"
      ],
      validationAppointments: {
        hasAppointment: false,
        nextAppointment: ""
      },
      showCreateNewReferralOption: false
    };
  },
  components: {
    Tab1,
    Tab2,
    Tab3,
    Tab4,
    Tab5,
    Tab6,
    Tab7,
    Header: TabHeader
  },
  methods: {
    selectTab(tab) {
      this.activateTab(tab);
    },
    selectTabById(tabNumber) {
      if (!tabNumber) return;

      const tab = this.getTabByNumber(tabNumber);
      if (!tab || (tab && tab.isActive)) return;

      this.activateTab(tab);
      return tab;
    },
    getTabByNumber(tabNumber) {
      return this.getTabs.find(t => t.id === `Tab${tabNumber}`);
    },
    setButtonVisibility(value) {
      this.keyHeader = this.keyHeader * -1;
      this.showSavedButton = value;
    },
    setTabVisibility(tabs, value) {
      value = value === undefined || value === null ? true : value;
      this.tabs.map(s => {
        const tabId = s.id;
        if (tabs.includes(parseInt(tabId.slice(tabId.length - 1)))) {
          s.visibility = value;
        }

        //set post-registry active tab (if apply)
        if (this.hasToNaviateToPostRegistryTab) {
          if (s.id === POST_REGISTRY_TAB_ID) {
            s.isActive = true;
          } else {
            s.isActive = false;
          }
        }

        //verify if has appointment
        if (s.id === APPOINTMENT_TAB_ID && s.visibility === true) {
          this.hasAppointment = true;
        }
        return s;
      });
    },
    setTabDisability(tabs, value) {
      value = value || false;
      tabs.forEach(tabNumber => {
        const tab = this.getTabByNumber(tabNumber);
        if (!tab) return;

        tab.isDisabled = value;
      });
    },
    resetTabToValid() {
      this.tabs.forEach(tab => {
        tab.invalid = false;
      });
    },
    async activateTab(tab) {
      if (tab.isActive || tab.isDisabled) return;

      const canLeavePage = await this.$store.dispatch("canLeavePage");
      if (!canLeavePage) return;

      if (this.currentTab) this.currentTab.isActive = false;
      tab.isActive = true;
    },
    setInvalidTabs(tabNumberList, isInvalid) {
      tabNumberList = tabNumberList || [];
      isInvalid = isInvalid || false;

      this.resetTabToValid();

      tabNumberList.forEach(tabNumber => {
        const tab = this.getTabByNumber(tabNumber);
        if (tab) {
          tab.invalid = isInvalid;
        }
      });
    },
    pageTabs() {
      let status = store.getters.SelectedStudent.status;
      if (status != undefined) {
        let hasInitialEvaluationFlag =
          store.getters["$_student/getStudentPreRegistry"]
            .hasInitialEvaluationFlag;
        let listOfTabs = [];
        this.isPostRegistry =
          store.getters["$_student/getStudentPreRegistry"].isPostRegistry;
        switch (status) {
          case StudentStatuses.Disponible:
            listOfTabs = [1];
            break;
          case StudentStatuses.PreRegistro:
            listOfTabs = [2, 3, 4];
            break;
          case StudentStatuses.Registro:
            listOfTabs = [2, 3, 4, 5, 6];
            break;
          default:
            if (this.isPostRegistry) {
              if (hasInitialEvaluationFlag == "0") {
                listOfTabs = [5, 6, 7];
              } else {
                listOfTabs = [5, 6];
              }
            } else {
              listOfTabs = [2, 3, 4, 5, 6, 7];
            }
        }

        this.setTabVisibility(listOfTabs, true);

        if (this.isPostRegistry) {
          this.selectTabById(6);
          // this.setTabVisibility([1], false);
        }
      }
    },
    async onCreateNewReferral() {
      if (this.validationAppointments.hasAppointment) {
        this.ShowToast(
          "Error",
          `No es posible proceder con la creación del referido ya que se encontraron
           espacios disponibles en (${this.validationAppointments.nextAppointment}), para la disciplina seleccionada.`,
          "error"
        );
        return;
      }
      try {
        const currentTab = this.$refs.currenTab;
        const {
          availableAppointmentRef,
          referralReason: referralReasonRef
        } = currentTab.$refs;
        const referralDisciplineRef =
          availableAppointmentRef.$refs.disciplineField;
        const areValid = await Promise.all([
          referralDisciplineRef.validate(),
          referralReasonRef.validate()
        ]);
        const isInvalid = areValid.includes(false);
        if (isInvalid) {
          this.ShowToast("Alerta", "Información Incompleta.", "error");
          return;
        }

        let confirmed = await this.ShowCancelModal(
          "Confirmación",
          "¿Está seguro que desea proceder con la creación del referido?",
          "Si",
          "No"
        );

        if (!confirmed) return;

        const referralReason = currentTab.referralReason;
        const disciplineTypeId =
          availableAppointmentRef.options?.discipline?.id;
        const studentSieId = Number(
          this.$store.getters["$_student/StudentSie"]
        );
        const payload = { disciplineTypeId, studentSieId, referralReason };
        const {
          data
        } = await appointmentServiceManager.createNewInitialReferral(payload);
        if (data) {
          this.ShowToast(
            "Proceso exitoso",
            "La Información ha sido guardada exitosamente.",
            "success"
          );
          this.$router.go(-1);
        } else {
          this.ShowToast(
            "Error",
            "Ocurrio un problema creando el referido",
            "error"
          );
        }
      } catch (error) {
        const message = error.response?.data?.message ?? error.message;
        this.ShowToast("Error", message, "error");
      }
    },
    onSetShowCreateNewReferralOption(value) {
      this.showCreateNewReferralOption = value;
    }
  },
  computed: {
    ...mapState(["selectedStudentPreRegistry"]),
    getTabs() {
      return this.tabs.filter(t => t.visibility);
    },
    currentTab() {
      return this.tabs.find(t => t.isActive);
    },
    statusExcludedFromNavToPostRegistry() {
      let hasInitialEvaluationFlag =
        store.getters["$_student/getStudentPreRegistry"]
          .hasInitialEvaluationFlag;
      if (hasInitialEvaluationFlag == "1") {
        return [
          StudentStatusesCode.PreRegistro,
          StudentStatusesCode.Disponible
        ];
      } else {
        return [
          StudentStatusesCode.PreRegistro,
          StudentStatusesCode.Disponible,
          StudentStatusesCode.Registro
        ];
      }
    },
    getPageTitle() {
      let isPostRegistry = this.$store.getters[
        "$_student/getStudentPreRegistry"
      ].isPostRegistry;
      let serviceTypeDesc =
        isPostRegistry === false
          ? "Registro: Citas-Evaluación inicial"
          : "Registro: Citas-Evaluación adicional";

      return serviceTypeDesc;
    },
    hasToNaviateToPostRegistryTab() {
      if (
        this.selectedStudentPreRegistry.statusId === 0 ||
        !this.selectedStudentPreRegistry.statusId
      )
        return false;
      return !this.statusExcludedFromNavToPostRegistry.includes(
        this.selectedStudentPreRegistry.statusId
      );
    }
  },
  destroyed() {
    this.persistData(["tabs"], true);
  },
  beforeRouteEnter(to, from, next) {
    // TODO: Esta implementacion de tabs requiere de una refactorizacion. Temporalmente para manejar las rutas cuando se navega
    // a otra pantalla, se pudiera agregar una propiedad en el store para evitar aplicar logica aqui
    next(vm => {
      const tabIndex = 4;
      if (
        from.name == "student-evaluation-history-add" &&
        JSON.stringify(vm.$store.state.postRegistryState) == "{}"
      ) {
        vm.selectTabById(tabIndex);
      }

      if (!vm.perstistTempRoutesPostRegistry.includes(from.name)) {
        vm.$store.commit("$_student/setPostRegistryState", {});
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    this.showCreateNewReferralOption = false;
    this.validationAppointments = {
      hasAppointment: false,
      nextAppointment: ""
    };
    if (!this.perstistTempRoutesPostRegistry.includes(to.name)) {
      this.$store.commit("$_student/setPostRegistryState", {});
    }
    next();
  },
  watch: {
    "$store.getters.SelectedStudent.status": {
      handler() {
        this.pageTabs();
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
ul.tab-list li > a.disabled {
  color: #e2e2e2;
}
i.warning {
  color: #ff5b5c;
  margin-left: 3px;
}
a.active i.warning {
  color: #fff;
}
.tabs-five {
  width: 20%;
}
.tabs-six {
  width: calc(80% / 6);
  cursor: pointer;
}
.tabs-seven {
  width: calc(80% / 7);
  cursor: pointer;
}
.tabs-seven {
  width: calc(100% / 7);
  cursor: pointer;
}
.tab-content-spacing {
  margin-left: 14px;
  margin-right: 14px;
}

@media screen and (max-width: 768px) {
  .nav {
    display: unset !important;
  }
  .Sub-menu .shadow-bottom {
    height: unset !important;
  }
}
</style>
